import api from "../axios";

// Saldo
export async function getSaldo(id_user) {
  const response = await api.get(`/orgadots/saldo/${id_user}`);
  return response.data;
}

// Extrato
export async function getExtrato(id_user, page = 1, perPage = 20) {
  const response = await api.get(`/orgadots/extrato/${id_user}`, {
    params: { page, perPage },
  });
  return response.data;
}

// Credito/Debito manual
export async function creditoManual(id_user, tipo, valor, descricao) {
  const response = await api.post(`/orgadots/credito-manual`, {
    id_user,
    tipo,
    valor,
    descricao,
  });
  return response.data;
}

// Creditos mensais
export async function getCreditos(page = 1, perPage = 50) {
  const response = await api.get(`/orgadots/creditos`, {
    params: { page, perPage },
  });
  return response.data;
}

/** Linhas em draft (rascunho/simulado) do gestor para a divisão. */
export async function getRascunhoAberto(tipo) {
  const response = await api.get(`/orgadots/creditos/abertos`, {
    params: { tipo },
  });
  return response.data;
}

export async function getCreditoById(id) {
  const response = await api.get(`/orgadots/creditos/${id}`);
  return response.data;
}

/** Salva o conjunto do rascunho: cada linha com suas próprias datas/percentuais. */
export async function salvarRascunho(tipo_divisao, linhas) {
  const response = await api.post(`/orgadots/creditos/salvar`, {
    tipo_divisao,
    linhas,
  });
  return response.data;
}

export async function descartarRascunho(tipo) {
  const response = await api.delete(`/orgadots/creditos/abertos`, {
    params: { tipo },
  });
  return response.data;
}

export async function excluirCredito(id) {
  const response = await api.delete(`/orgadots/creditos/${id}`);
  return response.data;
}

export async function calcularLinha(id) {
  const response = await api.post(`/orgadots/creditos/${id}/calcular-linha`);
  return response.data;
}

/** Atualiza os valores de uma linha e recalcula só ela (sem mexer nas outras). */
export async function atualizarCalcularLinha(id, valores) {
  const response = await api.post(
    `/orgadots/creditos/${id}/atualizar-calcular`,
    valores
  );
  return response.data;
}

export async function simularTodos(ids) {
  const response = await api.post(`/orgadots/creditos/simular`, { ids });
  return response.data;
}

export async function aprovarCreditos(ids) {
  const response = await api.post(`/orgadots/creditos/aprovar`, { ids });
  return response.data;
}
